import type { CategoryItem } from '@/constants/product/category';
import { Box, Button, Grid, GridItem } from '@chakra-ui/react';
import NextImage from 'next/image';
import { SafeLink } from '@/components/ui/SafeLink';

type BrandSectionProps = {
  onClose: () => void;
  items: CategoryItem[];
};

const BrandSection = ({ onClose, items }: BrandSectionProps) => {
  return (
    <>
      <Grid templateColumns="repeat(2, 1fr)" gap="8px" padding="8px" backgroundColor="neutral.5" borderRadius="8px">
        {items.map((item) => (
          <GridItem key={item.name} textAlign="center">
            <SafeLink href={item.url} asChild onClick={onClose}>
              <Box
                width="100%"
                height="60px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                backgroundColor="common.100"
                borderRadius="6px"
                padding="8px"
                cursor="pointer"
              >
                <NextImage
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  width={120}
                  height={44}
                  style={{
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                    maxWidth: '120px',
                    maxHeight: '44px',
                  }}
                />
              </Box>
            </SafeLink>
          </GridItem>
        ))}
      </Grid>
      <Box textAlign="center" mt="24px" mb="16px">
        <Box as="span" width="100%" maxWidth="280px" display="inline-block">
          <SafeLink href="/all-brands">
            <Button
              variant="outline"
              width="100%"
              borderColor="brand.50"
              color="brand.50"
              borderRadius="8px"
              height="48px"
              onClick={onClose}
            >
              View More Brands
            </Button>
          </SafeLink>
        </Box>
      </Box>
    </>
  );
};

export default BrandSection;
